import { inject } from 'inversify';
import { appendToFormData, urlMaker } from '@core/utils';
import { IRepo, IRepoResponse } from '@core/repo';
import { HttpClientType } from '@core/http';
import type { IHttpClient } from '@core/http';
import { bind } from '@infra/container';

export type IChangeInspectionStatusRepoResponse = IRepoResponse<200> | IRepoResponse<400 | 422 | 500, string>;

export type IChangeInspectionStatusRepo = IRepo<[string, { state_id: number }], IChangeInspectionStatusRepoResponse>;

export const ChangeInspectionStatusRepoType = Symbol.for('ChangeInspectionStatusRepo');

@bind(ChangeInspectionStatusRepoType)
export class ChangeInspectionStatusRepo implements IChangeInspectionStatusRepo {
  constructor(@inject(HttpClientType) private readonly httpClient: IHttpClient) {}

  async execute(id: string, data: { state_id: number }) {
    try {
      const body = new FormData();
      appendToFormData(data, body);

      const url = urlMaker(`/api/admin/branch_inspections/${id}/status`);
      const result = await this.httpClient.post({ url, body });

      if (result.status === 200) {
        return {
          status: 200 as 200,
          response: null,
        };
      } else if (result.status === 422) {
        const errors = result.data.errors;
        const errorMessage = Object.values(errors).flat().join(', ');
        return {
          status: 422 as 422,
          response: errorMessage,
        };
      } else {
        return {
          status: 400 as 400,
          response: result.data.message || 'Status dəyişdirilə bilmədi',
        };
      }
    } catch (e) {
      return {
        status: 500 as 500,
        response: 'Şəbəkə ilə əlaqə qurula bilmədi',
      };
    }
  }
}
